// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
import localizeValue from '../utils/localizeValue';
//
import Avatar from '../components/Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user.image?.image}
      alt={localizeValue(user.name)}
      color={user.image?.image ? 'default' : createAvatar(localizeValue(user.name)).color}
      {...other}
    >
      {createAvatar(localizeValue(user.name)).name}
    </Avatar>
  );
}
